import { render } from "./QuizModal.vue?vue&type=template&id=ccffac5a&scoped=true"
import script from "./QuizModal.vue?vue&type=script&lang=js"
export * from "./QuizModal.vue?vue&type=script&lang=js"

import "./QuizModal.vue?vue&type=style&index=0&id=ccffac5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ccffac5a"

export default script